module.exports = __webpack_public_path__ + "img/phox.10062c99.png";